module.exports = __webpack_public_path__ + "static/media/faq_(2).e9921bb7.gif";